<section class="sh-dialog__content sh-overflow-container">
  <div class="header">
    <span>
      {{'advanced-search.filter-groups.relation' | translate }}:
      <select class="sh-select--inline" [(ngModel)]="globalLogicalOperand">
        @for (option of matchingOptions; track option) {
          <option [value]="option.value">{{ option.label }}</option>
        }
      </select>
    </span>
  </div>

  <div class="sh-filter-groups">
    @for (group of $filterGroups(); track group; let groupIndex = $index) {
      <div class="sh-filter-group">
        <div class="sh-action-bar">
          <div class="sh-action-bar__group">
            <b class="sh-action-bar__group__item">{{'advanced-search.filter-groups.label' | translate }} {{groupIndex + 1}}</b>
          </div>
          <div class="sh-action-bar__group">
            <div class="sh-action-bar__group__item">
              <div class="sh-action-group -sh-condense">
                <button class="sh-pure-icon-button" style="margin-right: 0.25rem" (click)="removeGroup(groupIndex)">
                  <svg sh-icon [name]="'trash'" aria-hidden="true" class="sh-icon-button__icon"></svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="group-header">
          <span>{{'advanced-search.filters.relation' | translate }}: </span>
          <select class="sh-select--inline" [(ngModel)]="group.LogicalOperand">
            @for (option of matchingOptions; track option) {
              <option [value]="option.value">{{ option.label }}</option>
            }
          </select>
        </div>
        <div class="filters">
          <sh-advanced-search-group
            [i18n]="i18n"
            [profileFields]="mergedProfileFieldsStream$ | async"
            [fieldDefinitionOptions]="fieldTypeOptions"
            [filters]="group.Terms"
            (filtersChanged)="filtersChanged(groupIndex, $event)"
          ></sh-advanced-search-group>
        </div>
      </div>
    }

    <div class="sh-action-group -sh-align-end">
      <sh-action-item class="sh-action-group__item" [item]="addGroupActionItem"></sh-action-item>
    </div>
  </div>
</section>

<footer class="sh-dialog__footer">
  <div class="sh-action-group -sh-align-end">
    @for (item of $dialogActionItems(); track item) {
      <sh-action-item [item]="item" class="sh-action-group__item"></sh-action-item>
    }
  </div>
</footer>
